import { render, staticRenderFns } from "./i4pro-fab-transition.vue?vue&type=template&id=ba2d260e&scoped=true"
import script from "./i4pro-fab-transition.vue?vue&type=script&lang=js"
export * from "./i4pro-fab-transition.vue?vue&type=script&lang=js"
import style0 from "./i4pro-fab-transition.vue?vue&type=style&index=0&id=ba2d260e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2d260e",
  null
  
)

export default component.exports